export default __webpack_public_path__ + "static/media/divider-bg.99eafb2c.png";